var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Ucreaty")]),_c('div',{staticClass:"box"},[_c('div',{staticClass:"deviceBox"},[_c('DeviceComponent',{attrs:{"Account":123123}})],1),_c('i',{staticClass:"el-icon-upload",staticStyle:{"font-size":"100px","margin-bottom":"200px"}}),_c('div',{staticClass:"deviceBox"},[_c('DeviceComponent',{attrs:{"Account":456456}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }